export default "__VITE_ASSET__C$uYPJCi__"